<div class="outer-container">
  <span class="currentStatusTitile"></span>
  <div class="console-container">
    <div class="input-wrapper">
      <div class="row">
        <h6>Are you still there?
          You will be logged out in {{timeLeft}} seconds.
        </h6>
      </div>
      <div class="text-center">
        <button class="main-btn mt-3">
          <span (click)="resetTimer()">I'm Here</span>
        </button>
      </div>
    </div>
  </div>
</div>  
